import { BaseService } from 'core/services';
import AreaOfCareRouteService from './AreaOfCareRouteService';

class AreaOfCareService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new AreaOfCareRouteService());
    }
}

export default AreaOfCareService;
